import { render, staticRenderFns } from "./wrapperObjectiveList.vue?vue&type=template&id=07764c94&"
import script from "./wrapperObjectiveList.vue?vue&type=script&lang=js&"
export * from "./wrapperObjectiveList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports